import React, { Component } from "react";
import { connect } from "react-redux";
import {
  onManagechallengesSelectedTab,
  fetchManageChallengesList,
} from "ManagechallengesActions";

class ManagechallengesInside extends Component {
  constructor(props) {
    super(props);
  }

  onMenuSelected() {
    this.props.onManagechallengesSelectedTab(this.props.menu);
  }

  render() {
    let { selected } = this.props;
    let styleClass = selected
      ? "btn btn-custom-table-blue"
      : "btn btn-custom-white-lg";

    return (
      <button
        type="button"
        className={styleClass}
        onClick={this.onMenuSelected.bind(this)}
      >
        {this.props.menu.sectionName}
      </button>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    managechallengesSelectedTab: state.managechallengesSelectedTab,
    selected: ownProps.menu.key === state.managechallengesSelectedTab,
  };
}

export default connect(mapStateToProps, {
  onManagechallengesSelectedTab,
  fetchManageChallengesList,
})(ManagechallengesInside);
